import React from "react";
import EmailTemplatesContainer from "../../../modules/OrganizationEmailTemplates/containers/EmailTemplatesContainer/EmailTemplatesContainer";
import { EMAIL_TEMPLATE_SCOPE_GEN } from "../../../modules/OrganizationEmailTemplates/hooks/EmailTemplatesHooks";

// General Admin: standard email templates (genEmailTemplates).
// Reuses the org list container in "gen" scope.
const GAEmailTemplates = () => {
  return <EmailTemplatesContainer scope={EMAIL_TEMPLATE_SCOPE_GEN} />;
};

export default GAEmailTemplates;
